import styled from 'styled-components';
import {DimensionProps} from '../customTypes';
import { defaultFadeInAnimation, defaultSlideUpAnimation } from '../../../lib/utils/AnimationUtils';

export const LandingpageButtonContainer = styled.div<DimensionProps>`
    width: ${(DimensionProps) => DimensionProps.width}rem;
    cursor: pointer;
    animation: ${defaultSlideUpAnimation(0.7, 0.2)}, ${defaultFadeInAnimation(0.7, 0.2)};
    z-index: 50;
`;

export const LandingpageButtonLabelContainer = styled.div`
    position: absolute;
    top: 0.2rem;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
`;

export const LandingpageButtonText = styled.span`
    color: #04b7ec;
    font-size: 1.5rem;
    font-weight: 600;
`;

export const LandingpageButtonArrow = styled.img`
  height: 1rem;
  width: 0.5rem;
`;

export const LandingpageButtonArrowLeft = styled.img`
  height: 1rem;
  width: 0.5rem;
  transform: rotate(180deg);
`;
